'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "conversation", "selected", "unread", "focused", "ownerState", "slots", "slotProps"];
import * as React from 'react';
import useSlotProps from '@mui/utils/useSlotProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const ConversationListItemActions = /*#__PURE__*/React.forwardRef(function ConversationListItemActions(props, ref) {
  const _ref = props,
    {
      children,
      conversation,
      selected = false,
      unread = false,
      focused = false,
      ownerState: ownerStateProp,
      slots,
      slotProps
    } = _ref,
    other = _objectWithoutPropertiesLoose(_ref, _excluded);
  const ownerState = {
    conversation,
    selected,
    unread,
    focused,
    variant: ownerStateProp?.variant ?? 'default'
  };
  void ownerStateProp;
  const Root = slots?.root ?? 'div';
  const rootProps = useSlotProps({
    elementType: Root,
    externalSlotProps: slotProps?.root,
    externalForwardedProps: other,
    ownerState,
    additionalProps: {
      ref
    }
  });
  return /*#__PURE__*/_jsx(Root, _extends({}, rootProps, {
    children: children
  }));
});
if (process.env.NODE_ENV !== "production") ConversationListItemActions.displayName = "ConversationListItemActions";